import {
  createElementFromHTML,
  passedHTMLObject,
  wrapElement,
} from "./helpers";
import merge from "lodash/merge";
import Masonry from "masonry-layout";
import LazyLoadImages from "./lazyLoadImages";
import LazyLoad from "vanilla-lazyload";

// const status = {
//   initialized: "INITIALIZED",
//   loading: "LOADING",
//   done: "DONE",
//   error: "ERROR",
// };

class InfiniteScroll {
  classPrefix = "infinite-scroll";
  status = 'DONE';
  wrapper = null;
  listElement = null;
  msnry = null;
  lazy = null;

  observerElement = null;
  usingOwnObserverElement = false;
  observer = null;
  observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.25,
  };

  currentPage = 1;
  maxPages = -1;

  defaultOptions = {
    observerElement: null,
    maxPages: -1,
    fetchUrl: null,
    fetchOptions: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  };

  options = {};

  constructor(listElement = null, options = {}) {
    this.options = merge(this.defaultOptions, options);
    this.listElement = passedHTMLObject(listElement);
    if (this.options.observerElement !== null) {
      this.usingOwnObserverElement = true;
      this.observerElement = passedHTMLObject(this.options.observerElement);
      this.observerElement.dataset.maxpages
        ? (this.maxPages = parseInt(this.observerElement.dataset.maxpages))
        : null;
      this.observerElement.dataset.currentpage
        ? (this.currentPage = parseInt(
            this.observerElement.dataset.currentpage
          ))
        : null;
      this.observerElement.removeAttribute("data-maxpages");
      this.observerElement.removeAttribute("data-currentpage");
    } else this.createObserverElement();

    if (
      this.options.currentPage !== null &&
      this.options.currentPage !== undefined
    )
      this.currentPage = this.options.currentPage;

    if (this.currentPage !== 0) {
      this.msnry = new Masonry(this.listElement, {
        itemSelector: ".item",
      });
    }

    this.lazy = new LazyLoadImages();
  }

  mc = (className) => `${this.classPrefix}_${className}`;

  createWrapperElement = () => {
    const wrapper = document.createElement("div");
    wrapper.classList.add(this.mc("wrapper"));
    wrapper.dataset.status = this.status;
    this.wrapper = wrapper;
  };

  createObserverElement = () => {
    const className = this.mc("observer");
    const exists = document.querySelector(`.${className}`);
    if (exists) {
      this.observerElement = exists;
      this.usingOwnObserverElement = true;
      exists.dataset.maxpages
        ? (this.maxPages = parseInt(exists.dataset.maxpages))
        : null;
      exists.dataset.currentpage
        ? (this.currentPage = parseInt(exists.dataset.currentpage))
        : null;
      this.observerElement.removeAttribute("data-maxpages");
      this.observerElement.removeAttribute("data-currentpage");
      this.currentPage === this.maxPages
        ? this.hideObserverElement()
        : this.showObserverElement();
      return exists;
    }

    const observerElement = document.createElement("div");
    observerElement.classList.add(this.mc("observer"));
    this.observerElement = observerElement;
    return observerElement;
  };

  appendObserverElementToWrapper = () => {
    this.wrapper.appendChild(this.observerElement);
  };

  intersectionHandler = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      if (this.maxPages !== -1) {
        this.currentPage < this.maxPages && this.fetchData();
      } else {
        this.fetchData();
      }
    });
  };

  addIntersectionObserver = () => {
    this.observer = new IntersectionObserver(
      this.intersectionHandler,
      this.observerOptions
    );
    this.observer.observe(this.observerElement);
  };

  hideObserverElement = () => {
    this.observerElement.classList.add("removed");
  };

  showObserverElement = () => {
    this.observerElement.classList.remove("removed");
  };

  createContainer = () => {
    this.createWrapperElement();
    wrapElement(this.listElement, this.wrapper);
    this.appendObserverElementToWrapper();
    this.addIntersectionObserver();
  };

  changeStatus = (status) => {
    this.status = status;
    this.wrapper.dataset.status = status;
  };

  getUrlWithNextPage = () => {
    const nextPage = ++this.currentPage;

    window.history.replaceState(
      undefined,
      undefined,
      "?" +
        new URLSearchParams({
          page: String(nextPage),
        })
    );

    return (
      this.options.fetchUrl +
      "?" +
      new URLSearchParams(
        merge(
          {
            page: String(nextPage),
          },
          this.options.type === "html" ? { asHTML: true } : {}
        )
      )
    );
  };

  fetchData = () => {
    if (this.status === 'LOADING') return;
    this.changeStatus('LOADING');

    fetch(this.getUrlWithNextPage(), this.options.fetchOptions)
      .then((response) => response.json())
      .then((data) => {
        const {
          data: {
            posts,
            meta: { maxPages, currentPage },
          },
        } = data;

        this.currentPage = parseInt(currentPage);
        this.maxPages = parseInt(maxPages);

        if (currentPage === maxPages) this.hideObserverElement();

        if (this.options.type === "html") {
          if (this.currentPage === 1) {
            posts.forEach((post) => {
              const el = createElementFromHTML(post);
              this.listElement.appendChild(el);
              const img = el.querySelector("img");
              img && LazyLoad.load(el.querySelector("img"), {});
            });

            this.msnry = new Masonry(this.listElement, {
              itemSelector: ".item",
            });
          } else {
            posts.forEach((post) => {
              const el = createElementFromHTML(post);
              this.listElement.appendChild(el);
              this.msnry.appended(el);
              const img = el.querySelector("img");
              if (img) LazyLoad.load(img, {});
            });
          }
        }

        this.changeStatus('DONE');
      })
      .catch((err) => {
        this.changeStatus('ERROR');
        console.error(err);
      });
  };

  destroy = () => {
    this.observer.unobserve(this.observerElement);
    !this.usingOwnObserverElement && this.observerElement.remove();
    this.wrapper.replaceWith(...this.wrapper.childNodes);
    this.listElement.innerHTML = "";
    this.msnry.destroy();
  };

  init = () => {
    this.createContainer();
  };
}

export default InfiniteScroll;
